import * as React from 'react';
import {AsidePanelActionsButtonsGroup} from '../../../../asidePanel/components/AsidePanelActionsButtonsGroup/AsidePanelActionsButtonsGroup';
import {CardMoveToButtonHOC} from '../../../MoveToSection/hocs/CardMoveToButtonHOC/CardMoveToButtonHOC';
import {CopyCardHOC} from '../../../CopyCard/hocs/CopyCardHOC';
import {SetInWorkButtonHOC} from '../../../SetInWorkButton/hocs/SetInWorkButtonHOC/SetInWorkButtonHOC';
import {GetLinkButtonHOC} from '../../../GetLinkButton/hocs/GetLinkButtonHOC/GetLinkButtonHOC';
import {DeleteButtonHOC} from '../../../DeleteButtonSection/hocs/DeleteButtonHOC/DeleteButtonHOC';
import {IActionsInHeadSectionProps} from './types';
import './_ActionsInHeadSection.scss';
import {CardActionsTopMoreHOC} from '../../hocs/CardActionsTopMoreHOC/CardActionsTopMoreHOC';
import {ArchiveButtonsInHeadHOC} from '../../../ArchiveButton/hocs/ArchiveButtonHOC/ArchiveButtonHOC';
import { CLASS_ASIDE_PANEL_ACTIONS_HEAD } from '../../../../asidePanel/components/AsidePanelActions/constants';
import { AddToMyWorkButtonHOC } from '../../../AddToMyWorkButton/hocs/AddToMyWorkButtonHOC/AddToMyWorkButtonHOC';
import { EHintKey, HintHOC } from 'app/view/react_components/hints';
import { CARD_LINK } from 'app/view/react_components/aside_panel/cardDetails/ActionsInHeadSection/components/ActionsInHeadSection/constants';
import { GOOGLE_SPACING } from 'app/const';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { CardProgressHOC } from '../../../../../base/components/CardProgress/hocs/CardProgressHOC';

export function ActionsInHeadSection({
    boardId,
    cardId,
    isEssentialFeature,
    isShow,
}: IActionsInHeadSectionProps) {
    if (!isShow) {
        return null;
    }

    const { isCommentsColumn } = React.useContext(AsidePanelContext);

    const className = CLASS_ASIDE_PANEL_ACTIONS_HEAD;
    const classNameButtonHideTitle = 'head-actions__button-hide-title';
    const classNameButtonsRight = 'head-actions__buttons-right';
    const classNameCardLinkHint = className + '--card-link-hint';
    const classNameButtonCopy = 'head-actions__button--hint';
    const classNameProgressButton = className + '--progress-button';

    return (<>
        <div className={className}>
            <AsidePanelActionsButtonsGroup>

                <div className={classNameProgressButton}>
                    <CardProgressHOC
                        cardId={cardId}
                        isButton />
                </div>

                <div className={classNameButtonsRight}>
                    <CopyCardHOC
                        cardId={cardId}
                        boardId={boardId}
                        isCommentsColumn={isCommentsColumn}
                    />

                    <CardMoveToButtonHOC
                        boardId={boardId}
                        cardId={cardId}
                        isCommentsColumn={isCommentsColumn}
                    />

                    {!isEssentialFeature && <ArchiveButtonsInHeadHOC
                        boardId={boardId}
                        cardId={cardId}
                        isCommentsColumn={isCommentsColumn}
                    />}

                    <DeleteButtonHOC
                        boardId={boardId}
                        cardId={cardId}
                        isShowTooltip={true}
                        className={classNameButtonHideTitle}
                    />

                    <GetLinkButtonHOC
                        boardId={boardId}
                        cardId={cardId}
                        isShowTooltip={true}
                        className={`${classNameButtonHideTitle} ${classNameButtonCopy}`}
                    />
                        <HintHOC
                            className={classNameCardLinkHint}
                            key={EHintKey.CARD_LINK}
                            hintKey={EHintKey.CARD_LINK}
                            show
                            arrow={'up'}
                            direction={'down'}
                            value={CARD_LINK}
                            translate={{ top: -GOOGLE_SPACING }}
                            selector={`.${classNameButtonCopy}`}
                        />

                    <CardActionsTopMoreHOC
                        boardId={boardId}
                        cardId={cardId}
                    />
                </div>
            </AsidePanelActionsButtonsGroup>
        </div>
    </>);
}
